import { render, staticRenderFns } from "./Details2.vue?vue&type=template&id=b2780a2c&scoped=true&"
import script from "./details2.ts?vue&type=script&lang=ts&"
export * from "./details2.ts?vue&type=script&lang=ts&"
import style0 from "./Details2.vue?vue&type=style&index=0&id=b2780a2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2780a2c",
  null
  
)

export default component.exports